import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // PLACEHOLDER CONTROLLER FOR RESOURCES
    // Originally created to demonstrate import-maps
    console.log('resource connect', this.element);
  }
}
